let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("kTurq"), load("fviv5"), load("djb49"), load("kE4VR")]).then(() => parcelRequire('2zbyK'));